import {
  ROUTE_PATH_LIST,
  ROUTE_PATH_LIST_SETTINGS,
  ROUTE_UI_SECTION_NAME,
} from './route'

import CalendarIcon from '../icons/activities/calendar.svg'
import TariffsLimitsIcon from '../icons/activities/money.svg'
import ActivityIcon from '../icons/automate.svg'
import ProcessStructureIcon from '../icons/automate-processes.svg'
import ColorThemeIcon from '../icons/brush.svg'
import CompanyIcon from '../icons/company.svg'
import ConfigurationIcon from '../icons/configuration.svg'
import DocumentIcon from '../icons/document.svg'
import EpostBillingSettingsIcon from '../icons/e-post-billing.svg'
import EmailIcon from '../icons/email.svg'
import ExternalRequestIcon from '../icons/external-request.svg'
import GoogleDriveIcon from '../icons/google-drive-2.svg'
import UserDataIcon from '../icons/import-user-data.svg'
import IntegrationIcon from '../icons/integration.svg'
import LabelIcon from '../icons/label.svg'
import ManageAuthIcon from '../icons/lock-1.svg'
import ArrowBackIcon from '../icons/outline-arrow-left.svg'
import AdvancedIcon from '../icons/settings.svg'
import TemplateIcon from '../icons/template.svg'
import PersonalIcon from '../icons/user.svg'
import UserManagementIcon from '../icons/users-1.svg'
import WorkflowBotIcon from '../icons/workflow-bot.svg'

export const SETTINGS_MENU_BUTTON_BACK_ITEM = {
  alwaysAvailable: true,
  icon: ArrowBackIcon,
  title: 'SettingsMenu.ButtonBackKey',
  to: '/',
  uiSectionName: ROUTE_UI_SECTION_NAME.settingsCompany,
  withoutCounter: true,
}

export const SETTINGS_MENU_PERSONAL_ITEM = {
  icon: PersonalIcon,
  title: 'PersonalSettings.PageTitleKey',
  to: ROUTE_PATH_LIST_SETTINGS.personal,
  uiSectionName: ROUTE_UI_SECTION_NAME.settingsPersonal,
  webappTo: `${ROUTE_PATH_LIST.settings}/${ROUTE_PATH_LIST_SETTINGS.personal}`,
}

export const SETTINGS_MENU_COMPANY_ITEM = {
  icon: CompanyIcon,
  title: 'CompanySettings.PageTitleKey',
  to: ROUTE_PATH_LIST_SETTINGS.company,
  uiSectionName: ROUTE_UI_SECTION_NAME.settingsCompany,
  webappTo: `${ROUTE_PATH_LIST.settings}/${ROUTE_PATH_LIST_SETTINGS.company}`,
}

export const SETTINGS_MENU_COLOR_THEME_ITEM = {
  alwaysAvailable: true, //sections are only available in the redesign
  icon: ColorThemeIcon,
  title: 'ColorThemeSettings.PageTitleKey',
  to: ROUTE_PATH_LIST_SETTINGS.colorTheme,
  uiSectionName: ROUTE_UI_SECTION_NAME.settingsColorTheme,
}

export const SETTINGS_MENU_TARIFFS_LIMITS_ITEM = {
  alwaysAvailable: true, //sections are only available in the redesign
  icon: TariffsLimitsIcon,
  title: 'TariffsLimitsSettings.PageTitleKey',
  to: ROUTE_PATH_LIST_SETTINGS.tariffs,
  uiSectionName: ROUTE_UI_SECTION_NAME.settingsTariffsLimits,
}

export const SETTINGS_MENU_USER_MANAGMENT_ITEM = {
  icon: UserManagementIcon,
  title: 'UserManagementSettings.PageTitleKey',
  to: `${ROUTE_PATH_LIST.settings}/${ROUTE_PATH_LIST_SETTINGS.userManagement}`,
  uiSectionName: ROUTE_UI_SECTION_NAME.settings,
}

export const SETTINGS_MENU_TEXT_TEMPLATE_ITEM = {
  icon: TemplateIcon,
  title: 'TemplateSettings.PageTitleKey',
  to: `${ROUTE_PATH_LIST.settings}/${ROUTE_PATH_LIST_SETTINGS.template}`,
  uiSectionName: ROUTE_UI_SECTION_NAME.settings,
}

export const SETTINGS_MENU_GOOGLE_ITEM = {
  icon: GoogleDriveIcon,
  title: 'GoogleDriveIntegrationSettings.PageTitleKey',
  to: ROUTE_PATH_LIST_SETTINGS.googleDrive,
  uiSectionName: ROUTE_UI_SECTION_NAME.settingsGoogleDrive,
  webappTo: `${ROUTE_PATH_LIST.settings}/${ROUTE_PATH_LIST_SETTINGS.googleDrive}`,
}

export const SETTINGS_MENU_EMAIL_ITEM = {
  icon: EmailIcon,
  title: 'EmailIntegrationOldSettings.PageTitleKey',
  to: `${ROUTE_PATH_LIST.settings}/${ROUTE_PATH_LIST_SETTINGS.emailIntegrationOld}`,
  uiSectionName: ROUTE_UI_SECTION_NAME.settings,
}

export const SETTINGS_MENU_EMAIL_NEW_ITEM = {
  icon: EmailIcon,
  title: 'EmailIntegrationNewSettings.PageTitleKey',
  to: `${ROUTE_PATH_LIST.settings}/${ROUTE_PATH_LIST_SETTINGS.emailIntegrationNew}`,
  uiSectionName: ROUTE_UI_SECTION_NAME.settings,
}

export const SETTINGS_MENU_CALENDAR_ITEM = {
  alwaysAvailable: true, //sections are only available in the redesign
  icon: CalendarIcon,
  title: 'CalendarSettings.PageTitleKey',
  to: ROUTE_PATH_LIST_SETTINGS.calendar,
  uiSectionName: ROUTE_UI_SECTION_NAME.settingsCalendar,
}

export const SETTINGS_MENU_AUTH_ITEM = {
  icon: ManageAuthIcon,
  title: 'ManageAuthorizationsSettings.PageTitleKey',
  to: ROUTE_PATH_LIST_SETTINGS.manageAuth,
  uiSectionName: ROUTE_UI_SECTION_NAME.settingsManageAuth,
  webappTo: `${ROUTE_PATH_LIST.settings}/${ROUTE_PATH_LIST_SETTINGS.manageAuth}`,
}

export const SETTINGS_MENU_ERP_ITEM = {
  icon: IntegrationIcon,
  title: 'ERPIntegrationSettings.PageTitleKey',
  to: ROUTE_PATH_LIST_SETTINGS.erpIntegration,
  uiSectionName: ROUTE_UI_SECTION_NAME.settingsErpIntegration,
  webappTo: `${ROUTE_PATH_LIST.settings}/${ROUTE_PATH_LIST_SETTINGS.erpIntegration}`,
}

export const SETTINGS_MENU_IDWELL_ITEM = {
  icon: ExternalRequestIcon,
  title: 'IdwellToIdwellSettings.PageTitleKey',
  to: `${ROUTE_PATH_LIST.settings}/${ROUTE_PATH_LIST_SETTINGS.idwellToIdwell}`,
  uiSectionName: ROUTE_UI_SECTION_NAME.settings,
}

export const SETTINGS_MENU_IMPORT_DATA_ITEM = {
  icon: UserDataIcon,
  title: 'ImportUserDataSettings.PageTitleKey',
  to: `${ROUTE_PATH_LIST.settings}/${ROUTE_PATH_LIST_SETTINGS.import}`,
  uiSectionName: ROUTE_UI_SECTION_NAME.settings,
}

export const SETTINGS_MENU_CONFIG_ITEM = {
  icon: ConfigurationIcon,
  title: 'ConfigurationSettings.PageTitleKey',
  to: ROUTE_PATH_LIST_SETTINGS.configuration,
  uiSectionName: ROUTE_UI_SECTION_NAME.settingsConfiguration,
  webappTo: `${ROUTE_PATH_LIST.settings}/${ROUTE_PATH_LIST_SETTINGS.configuration}`,
}

export const SETTINGS_MENU_BOT_ITEM = {
  icon: WorkflowBotIcon,
  title: 'WorkflowBotSettings.PageTitleKey',
  to: `${ROUTE_PATH_LIST.settings}/${ROUTE_PATH_LIST_SETTINGS.workflowBot}`,
  uiSectionName: ROUTE_UI_SECTION_NAME.settings,
}

export const SETTINGS_MENU_PROCESS_STRUCTURE_ITEM = {
  icon: ProcessStructureIcon,
  title: 'ProcessStructureSettings.PageTitleKey',
  to: `${ROUTE_PATH_LIST.settings}/${ROUTE_PATH_LIST_SETTINGS.processStructure}`,
  uiSectionName: ROUTE_UI_SECTION_NAME.settings,
}

export const SETTINGS_MENU_ACTIVITY_ITEM = {
  icon: ActivityIcon,
  title: 'ActivityAutomationSettings.PageTitleKey',
  to: `${ROUTE_PATH_LIST.settings}/${ROUTE_PATH_LIST_SETTINGS.activityAutomation}`,
  uiSectionName: ROUTE_UI_SECTION_NAME.settings,
}

export const SETTINGS_MENU_AUTOMATED_ITEM = {
  icon: DocumentIcon,
  title: 'AutomatedDocumentRecognitionSettings.PageTitleKey',
  to: ROUTE_PATH_LIST_SETTINGS.automatedDocument,
  uiSectionName: ROUTE_UI_SECTION_NAME.settingsDocumentRecognition,
  webappTo: `${ROUTE_PATH_LIST.settings}/${ROUTE_PATH_LIST_SETTINGS.automatedDocument}`,
}

export const SETTINGS_MENU_EPOST_BILLING_ITEM = {
  alwaysAvailable: true, //sections are only available in the redesign
  icon: EpostBillingSettingsIcon,
  title: 'EpostBillingSettings.PageTitleKey',
  to: ROUTE_PATH_LIST_SETTINGS.epostBilling,
  uiSectionName: ROUTE_UI_SECTION_NAME.settingsEpostBilling,
}

export const SETTINGS_MENU_ADVANCED_ITEM = {
  icon: AdvancedIcon,
  title: 'AdvancedSettings.PageTitleKey',
  to: ROUTE_PATH_LIST_SETTINGS.advanced,
  uiSectionName: ROUTE_UI_SECTION_NAME.settingsAdvanced,
  webappTo: `${ROUTE_PATH_LIST.settings}/${ROUTE_PATH_LIST_SETTINGS.advanced}`,
}

export const SETTINGS_MENU_LABELS_ITEM = {
  alwaysAvailable: true, //sections are only available in the redesign
  icon: LabelIcon,
  title: 'LabelsSettings.PageTitleKey',
  to: ROUTE_PATH_LIST_SETTINGS.labels,
  uiSectionName: ROUTE_UI_SECTION_NAME.settingsLabels,
}
